import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IConditionDetail } from "interfaces";
import { EditConditionForm } from "./components";

export const EditCondition : React.FC = () => {

  const parse = useParse();
  const { params } = parse();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IConditionDetail>({
    resource: "content/about-us",
    id: `${params?.id}/detail`,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const conditionDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs />
      <div className="box-container">
        <p className="font-bold text-xl">{conditionDetailData?.title_vi}</p>
      </div>
      {conditionDetailData ? <EditConditionForm defaultConditionData={conditionDetailData} id={params?.id} /> : <></>}
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}